import { ApiError } from '../../apiError';
import { fetchWrapper } from '../../fetchWrapper';

export async function cancelRedeemableStoreCouponHistory(
  id: number,
  threeLetterCode: string
): Promise<void> {
  const response = await fetchWrapper(`/redeemable_store_coupons/${id}/cancellations`, {
    method: 'POST',
    threeLetterCode,
  });

  if (!response.ok) {
    const errorDetails = await response.json();
    throw new ApiError(
      `HTTP ${response.status} ${response.statusText}`,
      errorDetails.errors || [errorDetails.message]
    );
  }
}
